export default __webpack_public_path__ + "static/media/home-startup-blog-img-03.1e172743.jpg";